module.exports = "/_next/static/images/transparent-ledger-fa090d4a161b72eb0f2db0d6c0154949.jpg";